import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class ProcessQueue {
  async getProcessQueue(getOlderProcesses) {
    return (await fetchApi.get(`/process?getOlderProcesses=${getOlderProcesses}`)).data;
  }

  async startUpload(data) {
    return (await fetchApi.post(`/process/start`, data)).data;
  }

  async updateProcessQueue(ProcessQueue_id, data) {
    return (await fetchApi.patch(`/process/update/${ProcessQueue_id}`, data)).data;
  }
}
